module.exports = __webpack_public_path__ + "img/smcbg.ea0682e1.jpg";